// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let WizardExactPriceField = require("../wizard/WizardExactPriceField.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.bs.js");

let convertFragment = PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__Price__ExactPrice(props) {
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, props.draft);
  let match = draft.draftProperty.propertyType;
  let tmp;
  tmp = match === "FOR_SALE" ? "Price" : "Rent/month";
  return JsxRuntime.jsx(WizardExactPriceField.make, {
    price: props.price,
    labelText: tmp,
    width: 12,
    widthMd: 4
  });
}

let make = PropertyWizardRelay__KeyFacts__Price__ExactPrice;

exports.DraftFragment = DraftFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
